import React from 'react';
import { Link } from 'react-router-dom';

// Material Ui
import { Button } from '@mui/material';

const ButtonStyle = {
    backgroundColor: '#0DA15A',
    fontFamily: 'Poppins',
    padding: '.4rem 1.1rem',
    textTransform: 'none',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: '.8rem',
    color: 'white',
    boxShadow: '0 1px 2px rgba(13,161,90,.25), 0 6px 16px -6px rgba(13,161,90,.45)',
    ':hover': {
        backgroundColor: '#0A8449',
    },
    "@media (min-width: 700px)": {
        fontSize: '.9rem',
    },
}

const BillingsButton = ({ text, handleClick, type }) => {
    return (
        <>
            {
                type === 'userData' ?
                    <Button
                        onClick={ handleClick }
                        sx={ ButtonStyle }
                    >
                        { text }
                    </Button>
                :
                    <Link
                        style={{
                            backgroundColor: '#0DA15A',
                            textDecoration: 'none',
                            fontFamily: 'Poppins',
                            padding: '.55rem 1.1rem',
                            textTransform: 'none',
                            position: 'relative',
                            borderRadius: '10px',
                            textAlign: 'center',
                            fontWeight: '600',
                            fontSize: '.9rem',
                            display: 'flex',
                            color: 'white',
                            gap: '5px',
                            boxShadow: '0 1px 2px rgba(13,161,90,.25), 0 6px 16px -6px rgba(13,161,90,.45)',
                            '&:hover': {
                                backgroundColor: '#0A8449',
                            }
                        }}
                        to='/card?changePaymentMethod=true'
                    >
                        { text }
                    </Link>
            }
        </>
    )
}

export default BillingsButton;